import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * PageSEO - renders per-page <head> meta tags for SEO.
 * Wrap each page component's root with <PageSEO ... />.
 */
export default function PageSEO({
  title,
  description,
  canonical,
  ogImage = "https://www.yitalife.com/logo.png",
  structuredData = null,
}) {
  const fullTitle = title
    ? `${title} | Yitalife - Home Healthcare Uganda`
    : "Yitalife - Mobile Doctors & Home Healthcare in Uganda | Kampala";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical || "https://www.yitalife.com/"} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Yitalife" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@yitalife" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured data (page-specific) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}
